<template>
  <div class="main-content">
    <search-form ref="form" @search="handleSearch" :loading="searching"></search-form>

    <el-card shadow="nerver" v-loading="searching">
      <status-tabs class="right"></status-tabs>

      <el-row class="search">
        <el-col :span="8">
          <el-button v-if="needCompanyInfo" type="primary" @click="handleToEdit">{{ $t('album.create') }}</el-button>

          <el-button
            type="primary"
            class="export-all"
            :disabled="downloading"
            @click="handleDownloadAll"
          >
            {{ $t('common.export') }}
          </el-button>
        </el-col>
        <el-col :span="14" style="float: right;line-height: 28px;">
        </el-col>
      </el-row>

      <div class="album-block">
        <div v-for="album in tableData" :key="album.albumId" class="album-item">
          <div class="album-pic" v-if="album.albumPhotoList && album.albumPhotoList[0]" :style="{backgroundImage:`url(${album.albumPhotoList[0].url})`}" />

          <div v-else class="album-pic empty" />

          <svg-icon class="album-status-icon" :icon-class="`${statusIconMap[album.status]}-angle`"></svg-icon>

          <div class="album-edit">
            <el-button type="primary" icon="el-icon-edit" @click="handleToEdit(album)">{{ $t('common.modify') }}</el-button>
            <el-button type="ghost" icon="el-icon-share" @click="handleShowFlow(album)">{{ $t('album.showFlow') }}</el-button>
            <el-button
              v-if="album.status === 5 && (isBussiness || isAdmin)"
              type="success"
              class="send-mail"
              :loading="album.sending"
              @click="handleSendMail(album)"
            >
              {{ $t('album.sendMail') }}
            </el-button>
          </div>
          <i class="el-icon-download" @click="handleDownload(album)" />

          <div class="album-info">
            <el-tooltip effect="dark" :content="album.albumName" placement="top">
              <span class="album-name" :title="album.albumName">{{ $t('album.albumName') }}：{{ album.albumName }}</span>
            </el-tooltip>
            <el-tooltip effect="dark" placement="top" :content="album.singerName">
              <span class="singer-name" :title="album.singerName">{{ $t('common.singerName') }}：{{ album.singerName }}</span>
            </el-tooltip>
            <span class="album-publish-time">{{ $t('common.publicTime') }}：{{ album.saleTime }}</span>
          </div>
        </div>
      </div>

      <Empty v-if="!tableData.length"></Empty>

      <el-pagination
        v-if="pagination.total > 10"
        @size-change="handleSearch"
        @current-change="fetchAlbum"
        :page-sizes="[20, 50, 100, 1000]"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
    </el-card>

    <el-dialog
      v-if="showFlow"
      append-to-body
      width="400px"
      :title="$t('album.showFlow')"
      :close-on-click-modal="false"
      :visible.sync="showFlow"
      @close="handleCloseFlow"
    >
      <flow :status="flowAlbum.status" @cancel="handleCloseFlow"></flow>
    </el-dialog>
  </div>
</template>

<script>
import { fileToFrontend } from '@/utils/objUtil'
import albumService from '@/api/album.js'
import { statusMap, statusIconMap } from './mixin.js'
import SearchForm from './components/SearchForm.vue'
import Flow from './components/Flow.vue'
import StatusTabs from '@/components/StatusTabs/index.vue'
import Empty from '@/components/Empty/index.vue'
import { mapGetters } from 'vuex'
import { ROLE_TYPE_ENUM } from '@/views/person/const'

export default {
  name: 'AlbumList',
  components: {
    StatusTabs,
    SearchForm,
    Empty,
    Flow
  },
  data() {
    return {
      statusMap,
      statusIconMap,
      searchForm: {
        status: 0,
        albumName__icontains: '',
        singerName: '',
        upc: '',
        publicTime: '',
        insertTime: '',
        relateCompanyIdList: ''
      },
      tableData: [
      ],
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },
      downloading: false,
      popVisible: false,
      searching: false,
      showFlow: false,
      flowAlbum: null,
      selection: []
    }
  },
  computed: {
    /**
     * @returns {Object}
     */
    ...mapGetters([
      'userInfo',
      'isBussiness',
      'isAdmin',
      'copyrightCompanyList'
    ]),
    /**
     * @returns {Booelan}
     */
    needCompanyInfo() {
      return this.userInfo.roleType === ROLE_TYPE_ENUM.COMPANY.code || this.userInfo.roleType === ROLE_TYPE_ENUM.OTHER.code
    },
  },

  mounted() {
    this.fetchAlbum()
  },

  beforeDestroy() {
    this.$notify.closeAll()
  },
  methods: {
    /**
     * 根据搜索条件获取专辑列表
     */
    fetchAlbum() {
      const { pagination } = this.$data
      const formData = this.$refs.form.getFormData()
      const searchData = {
        page: pagination.current - 1,
        num: pagination.size,
        orderObjList: ['albumId desc'],
        ...formData
      }

      this.searching = true
      albumService.find(searchData).then(resp => {
        this.pagination.total = resp.total

        this.tableData = resp.list.map(item => {
          item.albumPhotoList = item.albumPhotoList.map(photo => fileToFrontend(photo))
          item.singerName = item.albumSingerList.map(singer => singer.singerName).join(',')
          item.downloading = false
          item.sending = false
          return item
        })
      }).catch(error => {
        console.error('专辑列表查询异常', error)
        this.$message.error(`${this.$t('album.searchError')}. ` + error.message)
      }).finally(_ => {
        this.searching = false
      })
    },

    handleSearch() {
      this.pagination.current = 1

      this.fetchAlbum()
    },

    handleToEdit(albumObj) {
      const query = {}
      if (albumObj) {
        query.id = albumObj.albumId
      } else {
        if (!(this.copyrightCompanyList[0] && this.copyrightCompanyList[0].cpCompanyId)) {
          return this.$confirm('未填写版权所属厂牌，无法新增专辑！', '提示', {
            confirmButtonText: '去填写',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(_ => {
            this.$router.push({ name: 'personEdit' })
          }).catch(_ => {})
        }
      }

      this.$router.push({ name: 'albumEdit', query })
    },

    handleStatusChange() {
      this.handleSearch()
    },

    handleSizeChange(size) {
      this.pagination.size = size
      this.fetchAlbum()
    },

    handleCurrentChange(current) {
      this.fetchAlbum()
    },

    handleShowFlow(album) {
      this.flowAlbum = album
      this.showFlow = true
    },

    handleCloseFlow() {
      this.showFlow = false
      this.flowAlbum = null
    },

    async handleSendMail(albumObj) {
      albumObj.sending = true
      try {
        await albumService.sendPlatformMail({ albumId: albumObj.albumId })
        this.$message({
          type: 'success',
          message: `${this.$t('album.sendMailSuccess')}!`
        })
      } catch (error) {
        this.$message({
          error,
          type: 'error',
          message: `发送邮件异常(${error.message})`
        })
      } finally {
        albumObj.sending = false
      }
    },

    async handleDownload(albumObj) {
      if (albumObj.downloading) {
        return this.$message.warning('正在导出中...')
      }
      albumObj.downloading = true
      await this.batchDownload([albumObj.albumId])
      albumObj.downloading = false
    },
    async handleDownloadAll() {
      const { tableData, downloading } = this
      if (downloading) {
        return this.$message.warning('正在导出中...')
      }
      const albumIdList = tableData.map(album => album.albumId)

      this.downloading = true
      await this.batchDownload(albumIdList)
      this.downloading = false
    },

    /**
     * @param {Array} albumIdList - 专辑 ID 数组
     */
    async batchDownload(albumIdList) {
      this.$notify({
        title: '通知',
        showClose: true,
        message: '正在生成导出任务,请关注邮件或站内通知...',
        position: 'bottom-right',
        iconClass: 'el-icon-loading',
        duration: 3000
      })
      try {
        await albumService.batchDownload({ albumIdList })
      } catch (error) {
        console.error(error)
        this.$message({
          type: 'error',
          message: `导出异常(${error.message})`
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.el-card::v-deep {
  .el-card__body {
    padding: 20px;
  }
}

.export-all {
  margin-left: 26px;
}

.search {
  .el-radio {
    margin-right: 8px;

    &+.el-radio {
      border-left: 1px solid #ccc;
    }

    /deep/ .el-radio__input {
      display: none;
    }
  }
  .link {
    cursor: pointer;
  }
}
.condition-form {
  background-color: #f0f2f5;
  margin-top: 8px;

  .el-form-item {
    margin-bottom: 0;
  }
}
.search-form {
  .search-item {
    width: 190px;
  }
}
.status-icon {
  width: 20px;
  height: 20px;
  vertical-align: sub;
}

.album-block {
  display: flex;
  margin: 16px 0;
  flex-wrap: wrap;
  justify-content: flex-start;

  $border: 25px;

  .album-status-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 56px;
    height: 56px;
    z-index: 1;
  }

  .el-icon-download {
    visibility: hidden;
    position: absolute;
    padding: 4px;
    right: 20px;
    top: 180px;
    width: 28px;
    height: 28px;
    border-radius: 14px;
    font-size: 20px;
    color: #32DDE9;
    cursor: pointer;

    &:hover {
      background-color: #fff;
    }
  }

  .album-item {
    position: relative;
    width: 228px;
    margin: 0 30px 30px 0;
    padding: 10px;
    border: 1px solid #e8e8e8;
    border-radius: 10px 10px 0 0;
    background-color: #E3E2EB;
    overflow: hidden;

    .send-mail {
      position: absolute;
      bottom: 10px;
      left: 0;
    }

    &:hover {
      box-shadow: 0 2px 8px rgba(0,0,0,.09);
      border-color: rgba(0,0,0,.09);

      .album-pic {
        filter: blur(3px);
      }

      .album-edit {
        opacity: 1;
      }

      .el-icon-download {
        visibility: visible;
      }
    }
    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  .album-edit {
    position: absolute;
    opacity: 0;
    left: 10px;
    top: 10px;
    width: 206px;
    height: 208px;
    line-height: 208px;
    background: rgba(0,0,0, .5);
    text-align: center;
    transition: opacity 0.3s ease-in-out;
  }

  .album-pic {
    display: block;
    border: none;
    height: 208px;
    border: none;
    background-size: cover;
    background-position: center;
    border-bottom: 1px solid #e8e8e8;
    transition: filter 0.3s ease-in-out;

    &.empty {
      background-size: cover;
      background-position: center;
      background-image: url("~@/assets/default_img.png");
      position: relative;
      &::before {
        content: '暂无图片';
        color: #fff;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .album-info {
    display: flex;
    flex-direction: column;
    border: none;
    margin-top: 6px;

    >span {
      color: #002444;
      display: block;
      line-height: 1.5;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: 600;
      line-height: 20px;
      white-space: nowrap;
    }

    .album-publish-time {
      font-weight: 400;
    }
  }
}
</style>
